export default __webpack_public_path__ + "static/media/Fidelity Life.ef73dbf1.svg";